import * as ActionType from "./organizationUser.type";

const initialState = {
  users: [],
  departments: [],
  roles: [],
  selectedUser: null,
  totalUsers: 0,
  loading: false,
  error: null,
  filters: {
    department: "",
    role: "",
    status: "",
    search: "",
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
  },
};

const organizationUserReducer = (state = initialState, action) => {
  switch (action.type) {
    // User Management
    case ActionType.GET_ORG_USERS:
      return {
        ...state,
        users: action.payload.users,
        totalUsers: action.payload.totalUsers,
        loading: false,
        error: null,
      };

    case ActionType.ADD_BULK_ORG_USER:
      return {
        ...state,
        users: [...action.payload, ...state.users],
      };

    case ActionType.ADD_ORG_USER:
      return {
        ...state,
        users: [action.payload, ...state.users],
        totalUsers: state.totalUsers + 1,
        loading: false,
        error: null,
      };

    case ActionType.UPDATE_ORG_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user._id === action.payload.userId ? action.payload.updatedData : user
        ),
        loading: false,
        error: null,
      };

    case ActionType.DELETE_ORG_USER:
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload),
        totalUsers: state.totalUsers - 1,
        loading: false,
        error: null,
      };

    case ActionType.TOGGLE_ORG_USER_STATUS:
      return {
        ...state,
        users: state.users.map((user) =>
          user._id === action.payload._id
            ? { ...user, isActive: action.payload.isActive }
            : user
        ),
        loading: false,
        error: null,
      };

    // Selection
    case ActionType.SELECT_ORG_USER:
      return {
        ...state,
        selectedUser: action.payload,
        error: null,
      };

    case ActionType.CLEAR_SELECTED_ORG_USER:
      return {
        ...state,
        selectedUser: null,
      };

    // Department Management
    case ActionType.GET_ORG_DEPARTMENTS:
      return {
        ...state,
        departments: action.payload,
        loading: false,
        error: null,
      };

    case ActionType.ADD_ORG_DEPARTMENT:
      return {
        ...state,
        departments: [...state.departments, action.payload],
        loading: false,
        error: null,
      };

    case ActionType.UPDATE_ORG_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.map((dept) =>
          dept._id === action.payload.departmentId
            ? action.payload.updatedData
            : dept
        ),
        loading: false,
        error: null,
      };

    case ActionType.DELETE_ORG_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.filter(
          (dept) => dept._id !== action.payload
        ),
        loading: false,
        error: null,
      };

    // Role Management
    case ActionType.GET_ORG_ROLES:
      return {
        ...state,
        roles: action.payload,
        loading: false,
        error: null,
      };

    case ActionType.ADD_ORG_ROLE:
      return {
        ...state,
        roles: [...state.roles, action.payload],
        loading: false,
        error: null,
      };

    case ActionType.UPDATE_ORG_ROLE:
      return {
        ...state,
        roles: state.roles.map((role) =>
          role.id === action.payload.roleId
            ? { ...role, ...action.payload.updatedData }
            : role
        ),
        loading: false,
        error: null,
      };

    case ActionType.DELETE_ORG_ROLE:
      return {
        ...state,
        roles: state.roles.filter((role) => role.id !== action.payload),
        loading: false,
        error: null,
      };

    // Filter and Search
    case ActionType.FILTER_ORG_USERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case ActionType.SEARCH_ORG_USERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          search: action.payload,
        },
      };

    case ActionType.SET_ORG_USER_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filterType]: action.payload.filterValue,
        },
      };

    // Loading and Error States
    case ActionType.SET_ORG_USER_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionType.CLEAR_ORG_USER_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default organizationUserReducer;
